import React from 'react';
import { useStore } from 'store';
import { Touchable } from 'components/styled';
import styled from 'styled-components';

const cartIcon = (
  <svg className="cart-icon" width="20px" height="18px" viewBox="0 0 22 20">
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g transform="translate(-1048.000000, -35.000000)" fillRule="nonzero" fill="#131413">
        <g transform="translate(1040.000000, 24.000000)">
          <path d="M8.25716787,11.0919873 C8.11588183,11.0919873 8.00135392,11.205694 8.00135392,11.3459556 C8.00135392,11.4862171 8.11588183,11.5999238 8.25716787,11.5999238 L11.1510633,11.5999238 C12.4842377,14.8976965 13.8111959,18.1966019 15.1401494,21.4967365 L13.9010633,24.4491429 C13.8313029,24.6048508 13.9692633,24.8103111 14.1408889,24.806273 L26.9315866,24.806273 C27.0667331,24.8088127 27.1910331,24.6865016 27.1910331,24.5523048 C27.1910331,24.4181333 27.0667331,24.2964571 26.9315866,24.2983365 L14.5246098,24.2983365 L15.6038377,21.7348317 L28.2346517,20.7348317 C28.3389215,20.724927 28.4327796,20.6451556 28.4584889,20.5443556 L29.9933713,13.9411937 C30.0266272,13.7937956 29.8976969,13.6327416 29.7455401,13.6316698 L12.5260633,13.6316698 L11.566761,11.2507175 C11.5284912,11.1567873 11.4289796,11.0909359 11.3269354,11.0919873 L8.25716787,11.0919873 Z M12.7339122,14.1396063 L29.4257726,14.1396063 L28.0028075,20.2507175 L15.5878238,21.2348444 L12.7339122,14.1396063 Z M16.6990284,26.3300825 C15.5718098,26.3300825 14.6525168,27.2427429 14.6525168,28.3618286 C14.6525168,29.4809397 15.5718098,30.3935746 16.6990284,30.3935746 C17.826247,30.3935746 18.7455401,29.4809397 18.7455401,28.3618286 C18.7455401,27.2427429 17.826247,26.3300825 16.6990284,26.3300825 Z M24.373447,26.3300825 C23.2462284,26.3300825 22.3269354,27.2427429 22.3269354,28.3618286 C22.3269354,29.4809397 23.2462284,30.3935746 24.373447,30.3935746 C25.5006657,30.3935746 26.4199587,29.4809397 26.4199587,28.3618286 C26.4199587,27.2427429 25.5006657,26.3300825 24.373447,26.3300825 Z M16.6990284,26.838019 C17.5497633,26.838019 18.2339122,27.5172571 18.2339122,28.3618286 C18.2339122,29.2064254 17.5497633,29.8856381 16.6990284,29.8856381 C15.8483447,29.8856381 15.1641447,29.2064254 15.1641447,28.3618286 C15.1641447,27.5172571 15.8483447,26.838019 16.6990284,26.838019 Z M24.373447,26.838019 C25.2241308,26.838019 25.9083308,27.5172571 25.9083308,28.3618286 C25.9083308,29.2064254 25.2241308,29.8856381 24.373447,29.8856381 C23.5227122,29.8856381 22.8385633,29.2064254 22.8385633,28.3618286 C22.8385633,27.5172571 23.5227122,26.838019 24.373447,26.838019 Z" id="Shape"></path>
        </g>
      </g>
    </g>
  </svg>
);
const Link = styled.a`
&:hover {
  text-decoration:none;
}
`

const Cart = () => {
  const [cartCount] = useStore('cartCount');
  const [settings] = useStore('settings');
  if (!cartCount) return null;
  return (
    <span>
      <Link href={settings && settings.shopping_cart_url}>
        <Touchable className="cart-container" noUnderline>
          {cartIcon}
          <span className="cart-number">
            {cartCount}
          </span>
        </Touchable>
      </Link>
    </span>
  )
}

export default Cart
